import { crmStateMatchesTicketType } from './crmCommunicationTypeAliases';

export { findCrmClosedStateId } from './crmCommunicationWorkflowStateIds';

function workflowStatesForType(crmStates, ticketType) {
  return (Array.isArray(crmStates) ? crmStates : []).filter((s) => {
    const types = Array.isArray(s?.applicable_types) ? s.applicable_types : null;
    return crmStateMatchesTicketType(types, ticketType);
  });
}

export function crmOutcomePhaseForTicketType(ticketType) {
  return ticketType === 'quote_request' ? 'followup' : 'outcome';
}

export function findCrmManualClosureStateIds(crmStates, phase, ticketType) {
  return workflowStatesForType(crmStates, ticketType)
    .filter((s) => String(s?.phase || '') === phase && String(s?.transition_type || '') === 'final_manually')
    .map((s) => Number(s.id));
}

export function ticketStatusMatchesManualClosure(crmStates, ticket, phase, ticketType) {
  const statusId = Number(ticket?.status_id ?? ticket?.status_crm_state_id ?? 0);
  if (!statusId) return false;
  return findCrmManualClosureStateIds(crmStates, phase, ticketType).includes(statusId);
}

/**
 * Parita ServiceTaskDetail::checkClosureApproval – používatelia priradení k úrovni zamietnutia a nižšie.
 */
export function canUserCloseCrmTicketFromApprovalRejection(ticket, user, state, ticketType) {
  if (!ticket || !user) return false;
  const crmStates = Array.isArray(state?.crm_states) ? state.crm_states : [];
  const manualIds = findCrmManualClosureStateIds(crmStates, 'approval', ticketType);
  if (manualIds.length === 0) return false;

  const statusId = Number(ticket?.status_id ?? ticket?.status_crm_state_id ?? 0);
  const rejectedStateId = manualIds.find((id) => id === statusId);
  if (!rejectedStateId) return false;

  const approvalRows = Array.isArray(ticket?.approval_requests)
    ? ticket.approval_requests
    : (Array.isArray(ticket?.approval) ? ticket.approval : []);
  const index = approvalRows.findIndex(
    (item) => Number(item?.approval_state_id ?? item?.approval_state?.id ?? 0) === rejectedStateId,
  );
  if (index < 0) return false;

  const levelIds = approvalRows.slice(index).map((item) => Number(item?.level_id)).filter((id) => id > 0);
  if (levelIds.length === 0) return false;

  const users = (Array.isArray(state?.crm_level_user_settings) ? state.crm_level_user_settings : [])
    .filter((setting) => levelIds.includes(Number(setting?.crm_level_id)))
    .map((setting) => Number(setting?.user_id))
    .filter((id) => id > 0);

  return users.includes(Number(user.id));
}

export function canUserCloseCrmTicketFromManualPhase(ticket, user, state, phase, ticketType) {
  if (!ticketStatusMatchesManualClosure(state?.crm_states, ticket, phase, ticketType)) return false;
  if (phase === 'approval') {
    return canUserCloseCrmTicketFromApprovalRejection(ticket, user, state, ticketType);
  }
  if (phase === 'execution') {
    const exec = ticket?.execution;
    const stateId = Number(exec?.executor_state ?? 0);
    const crmStates = Array.isArray(state?.crm_states) ? state.crm_states : [];
    const execState = crmStates.find((s) => Number(s.id) === stateId);
    if (!execState || String(execState.transition_type || '') !== 'final_manually') return false;
    return Number(exec?.executor_id ?? exec?.assignee_user_id ?? 0) === Number(user?.id)
      || !!user?.is_superuser;
  }
  if (phase === 'outcome' || phase === 'followup' || phase === 'inspection') {
    const outcomePhase = phase === 'inspection' ? crmOutcomePhaseForTicketType(ticketType) : phase;
    const rows = Array.isArray(ticket?.inspection) ? ticket.inspection : [];
    const manualIds = findCrmManualClosureStateIds(state?.crm_states, outcomePhase, ticketType);
    const row = rows.find((r) => manualIds.includes(Number(r?.inspector_state ?? r?.inspector_state_def?.id ?? 0)));
    if (!row) return false;
    return Number(row?.inspector_id) === Number(user?.id) || !!user?.is_superuser;
  }
  return false;
}
